<template>
    <div v-if="isVisible" class="floating-banner">
        <slot />

        <a v-if="isCloseable" class="floating-banner__close" @click="close">
            <svg-icon name="close" />
        </a>
    </div>
</template>

<script>
export default {
    props: {
        closeableId: {
            type: String,
            default: null,
        },
    },
    data() {
        return {
            isVisible: this.closeableId === null || !this.$cookies.get(`floating_banner_${this.closeableId}_closed`),
        };
    },
    computed: {
        isCloseable() {
            return this.closeableId !== null;
        },
    },
    methods: {
        close() {
            this.isVisible = false;
            this.$cookies.set(`floating_banner_${this.closeableId}_closed`, true);
        },
    },
};
</script>

<style lang="scss">
@import '@/sass/_variables.scss';

.floating-banner {
    box-sizing: border-box;
    display: flex;
    justify-content: center;
    background: $lilac-84;
    padding: 16px;
    position: fixed;
    bottom: 24px;
    max-width: 680px;
    width: calc(100% - 40px);
    left: 20px;
    border-radius: $default-border-radius;
    box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.2);
    z-index: $z-floating-info;
    text-align: center;
    @include font-size(16px);

    @include lg {
        width: fit-content;
        left: 50%;
        transform: translateX(-50%);
    }

    &__close {
        display: flex; // Centers the 'X' within it's container
        // Increases clickable area without affecting the layout
        margin: -8px -8px -8px 8px;
        padding: 8px;

        .svg-icon {
            width: 24px;
            height: 24px;
            color: $primary;
        }
    }
}
</style>
